(() => {
    useTalentNavFactory.$inject = ['$state', '$filter', 'hUser', 'userPermissions', 'brandServices'];

    function useTalentNavFactory($state, $filter, hUser, userPermissions, brandServices) {
        return function ($scope, isActiveLink, getBrandIds) {

            const talentNav = [{
                classNames: 'sb-main-items-container',
                icon: '../images/svgs/talent_filled.svg',
                search: {
                    enabled: true,
                    showInput: false,
                    term: ''
                },
                isVisible: async () => {
                    const brandIds = getBrandIds();
                    const policyParser = await userPermissions.getBrandPolicy(brandIds);
                    return (
                        !hUser.isTopLevelContext() &&
                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)
                    )
                },
                title: $filter('translate')('Talent acquisition'),
                sections: [
                    {
                        title: $filter('translate')('General'),
                        items: [
                            {
                                title: $filter('translate')('Hiring'),
                                icon: {
                                    unfilledSvg: '../images/svgs/hiring.svg',
                                    filledSvg: '../images/svgs/hiring_filled.svg'
                                },
                                redirectToWorkspace: true,
                                isActive: () => isActiveLink('appLayout.harriSH.dashboard-hiring'),
                                href: () => $state.href('appLayout.harriSH.dashboard-hiring'),
                                isVisible: async () => {
                                    const brandIds = getBrandIds();
                                    const policyParser = await userPermissions.getBrandPolicy(brandIds);
                                    return (
                                        !hUser.isTopLevelContext() &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)
                                    );
                                },
                            },
                            {
                                title: $filter('translate')('Onboarding'),
                                icon: {
                                    unfilledSvg: '../images/svgs/onboarding.svg',
                                    filledSvg: '../images/svgs/onboarding_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.harriSH.on-boarding'),
                                href: () => $state.href('appLayout.harriSH.on-boarding'),
                                isVisible: async () => {
                                    const brandIds = getBrandIds();
                                    const [
                                        isOnboardingJourneyEnabled,
                                        policyParser
                                    ] = await Promise.all([
                                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                                        userPermissions.getBrandPolicy(brandIds)
                                    ]);
                                    return (
                                        !hUser.isTopLevelContext() &&
                                        !isOnboardingJourneyEnabled &&
                                        hUser.isOnboardingServiceEnabled() &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)
                                    );
                                },
                            },
                            {
                                title: $filter('translate')('ATR'),
                                icon: {
                                    unfilledSvg: '../images/svgs/atr-settings.svg',
                                    filledSvg: '../images/svgs/atr-settings.svg',
                                },
                                isActive: () => isActiveLink('appLayout.harriSH.atrs-listing'),
                                href: () => {
                                    const brandIds = getBrandIds();
                                    return $state.href('appLayout.harriSH.atrs-listing', {brandId: brandIds[0]});
                                },
                                isVisible: async () => {
                                    let isATRWithMBEnabled = false;
                                    const brandIds = getBrandIds();
                                    const [
                                        isATRServiceEnabled,
                                        policyParser
                                    ] = await Promise.all([
                                        brandServices.check(brandServices.SERVICES.ATR, brandIds[0], true),
                                        userPermissions.getBrandPolicy(brandIds)
                                    ]);

                                    if (isATRServiceEnabled && hUser.data.user.brands_list?.length) {
                                        const atrSettings = await ATRAPI.getBrandSettings(hUser.data.user.brands_list[0].id);
                                        isATRWithMBEnabled = atrSettings.atr_type === "MB";
                                    }

                                    return (
                                        !hUser.isTopLevelContext() &&
                                        isATRWithMBEnabled &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)
                                    );
                                },
                            },
                            {
                                title: $filter('translate')('Approvals'),
                                icon: {
                                    unfilledSvg: '../images/svgs/approvals.svg',
                                    filledSvg: '../images/svgs/approvals_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.harriSH.job-approvals'),
                                href: () => $state.href('appLayout.harriSH.job-approvals', {brandId: hUser.getHighestBrandIdWithAccess()}),
                                isVisible: async () => {
                                    const checkIfApprovalFlowEnabled = (isApprovalFlowServiceEnabled, approvalFlowsSettings, policyParser) => {
                                        let teamlivePositionEnabled;
                                        let teamliveLocationPeriodEnabled;

                                        if (approvalFlowsSettings && approvalFlowsSettings.settings) {
                                            teamlivePositionEnabled = approvalFlowsSettings.settings.teamlive_position_enabled;
                                            teamliveLocationPeriodEnabled = approvalFlowsSettings.settings.teamlive_location_period_enabled;
                                        }

                                        return (
                                            isApprovalFlowServiceEnabled &&
                                            (
                                                policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS) ||
                                                teamlivePositionEnabled ||
                                                teamliveLocationPeriodEnabled
                                            )
                                        );
                                    };


                                    const brandIds = getBrandIds();
                                    const [
                                        isJobApprovalFlowServiceEnabled,
                                        isHrActionsServiceEnabled,
                                        isApprovalFlowServiceEnabled,
                                        approvalFlowsSettings,
                                        policyParser

                                    ] = await Promise.all([
                                        brandServices.check(brandServices.SERVICES.JOB_APPROVAL_FLOW, hUser.data.user.brands_list[0].id),
                                        brandServices.check(brandServices.SERVICES.HR_ACTIONS, hUser.data.user.brands_list[0].id),
                                        brandServices.check(brandServices.SERVICES.APPROVAL_FLOW, hUser.data.user.brands_list[0].id),
                                        ApprovalFlowAPI.getBrandApprovalFlowSettings(hUser.data.user.brands_list[0].id),
                                        userPermissions.getBrandPolicy(brandIds)
                                    ]);
                                    const canViewHrActionsTab = policyParser.has(userPermissions.PERMISSIONS.VIEW_HR_ACTIONS);
                                    const hasOverrideJobApprovalPermission = policyParser.has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS);
                                    const hasHrActionsApprovalsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_HR_ACTIONS_APPROVALS);
                                    let isApprovalFlowEnabled = checkIfApprovalFlowEnabled(isApprovalFlowServiceEnabled, approvalFlowsSettings, policyParser);

                                    return (
                                        !hUser.isTopLevelContext() &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                        (
                                            isJobApprovalFlowServiceEnabled ||
                                            (
                                                isHrActionsServiceEnabled &&
                                                canViewHrActionsTab &&
                                                (hasOverrideJobApprovalPermission || hasHrActionsApprovalsPermission)) ||
                                            isApprovalFlowEnabled
                                        )
                                    );
                                },
                            }
                        ]
                    },
                    {
                        title: $filter('translate')('Interviews'),
                        items: [
                            {
                                title: $filter('translate')('Interview availability'),
                                icon: {
                                    unfilledSvg: '../images/svgs/interview_availability.svg',
                                    filledSvg: '../images/svgs/interview_availability_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.harriSH.interview-availability'),
                                href: () => $state.href('appLayout.harriSH.interview-availability'),
                                automation: 'dashboardBarInterviewAvailabilityButton',
                                isVisible: async () => {
                                    const brandIds = getBrandIds();
                                    const [
                                        policyParser,
                                        isOnboardingJourneyEnabled
                                    ] = await Promise.all([
                                        userPermissions.getBrandPolicy(brandIds),
                                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true)
                                    ])
                                    return (
                                        !hUser.isTopLevelContext() &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                        !isOnboardingJourneyEnabled &&
                                        hUser.isInterviewV2ServiceEnabled()
                                    );
                                },
                            },
                            {
                                title: $filter('translate')('Interview schedule'),
                                icon: {
                                    unfilledSvg: '../images/svgs/interview_schedule.svg',
                                    filledSvg: '../images/svgs/interview_schedule_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.harriSH.manifest', {brand_id: hUser.getActiveBrandId()}),
                                href: () => $state.href('appLayout.harriSH.manifest'),
                                automation: 'TTSInterviewScheduleButton',
                                isVisible: async () => {
                                    const brandIds = getBrandIds();
                                    const [
                                        policyParser,
                                        isOnboardingJourneyEnabled,
                                    ] = await Promise.all([
                                        userPermissions.getBrandPolicy(brandIds),
                                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                                    ]);
                                    return (
                                        !hUser.isTopLevelContext() &&
                                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                        !isOnboardingJourneyEnabled
                                    );
                                },
                            },
                        ]
                    }
                ]
            }];

            return {
                talentNav
            };
        }
    }

    angular
        .module("harriApp")
        .factory('useTalentNavFactory', useTalentNavFactory);
})();